import { render, staticRenderFns } from "./AppointmentTypeIndex.vue?vue&type=template&id=a17d8566"
import script from "./AppointmentTypeIndex.vue?vue&type=script&lang=js"
export * from "./AppointmentTypeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports